import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { redirect, useLoaderData } from "react-router";

import classNames from "classnames";

import TournamentStandings from "./TournamentStandings";

import { store } from "../..";
import "../../assets/css/wibb/pages/tournaments.scss";
import {
    selectSelectedTournament,
    tournamentManagementActions,
} from "../../features/tourneymgmt/tournamentManagementSlice";
import { PrintIcon } from "../../lib/icons";
import { isChildTournament } from "../../lib/utils";
import { ITournament } from "../../types/api";

export const loader = async ({
    params,
    request,
}: {
    params: any;
    request: Request;
}) => {
    const { tournamentId, teamId } = params;
    const url = new URL(request.url);
    const currentPath = url.pathname;

    let tournaments = store.getState().tournamentmanagement.tournaments;
    let masterTournaments =
        store.getState().tournamentmanagement.masterTournaments;

    const tournamentsPromise = tournaments.length
        ? Promise.resolve()
        : store.dispatch(tournamentManagementActions.getTournaments());

    const masterTournamentsPromise = masterTournaments.length
        ? Promise.resolve()
        : store.dispatch(tournamentManagementActions.getMasterTournaments());

    await Promise.all([tournamentsPromise, masterTournamentsPromise]);

    if (!tournaments.length) {
        tournaments = store.getState().tournamentmanagement.tournaments;
    }

    if (!masterTournaments.length) {
        masterTournaments =
            store.getState().tournamentmanagement.masterTournaments;
    }

    store.dispatch(
        tournamentManagementActions.setselectedTournamentId(
            parseInt(tournamentId),
        ),
    );

    const tournament = selectSelectedTournament(store.getState());

    const masterTournament = isChildTournament(tournament)
        ? masterTournaments.find(t => t.id === tournament.parent)
        : tournament;

    const header = `${masterTournament?.name} ${isChildTournament(tournament) ? `${tournament?.ageLevel} ${masterTournament?.designation}` : ""}`;

    if (
        !tournament?.settings?.showToPublic &&
        !/^\/tournaments\/\d+\/overview\/?$/.test(currentPath)
    ) {
        return redirect(`/tournaments`);
    }

    if (
        isChildTournament(tournament) &&
        teamId &&
        !tournament.teams?.map(t => t.id).includes(parseInt(teamId))
    ) {
        return redirect(`/tournaments/${tournamentId}`);
    }

    return {
        masterName: masterTournament?.name,
        tournament,
        header,
    };
};

const Tournament = (): React.JSX.Element => {
    const { tournament } = useLoaderData() as {
        tournament: ITournament;
    };

    return (
        <div data-testid="tournamentContent">
            <Container className="tournament py-2 py-lg-0" fluid="xs">
                <Row>
                    <Col>
                        <div
                            className={classNames("d-flex", "mb-2", "noPrint")}
                        >
                            <h2 className={classNames("my-0")}>Standings</h2>
                            <PrintIcon
                                className="printerIcon d-none d-lg-inline-block"
                                size="2x"
                                title="Print standings"
                                onClick={() => window.print()}
                            />
                        </div>
                        <TournamentStandings
                            data={tournament}
                            expanded
                            bordered
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Tournament;
